export const enum ReservesCancel_enum {
  LIDOMA_CANCELLED = "cancelled_by_lidoma",
  HOST_CANCELLED = "cancelled_by_host",
  GUEST_CANCELLED = "cancelled_by_guest",
}

export const enum LIDOMA_CANCELLED_IN_COORDINATION_WITH {
  GUEST = "guest",
  HOST = "host",
}
